<template>
  <div>
    <!-- HEADER WITH MAINNAV: CONTACT-, WEBSITE- AND SERVICE-NAVIGATION -->

    <header>
      <div>
        <MenuMain />
      </div>
    </header>

    <!-- ASIDE LEFT - CONTENT NAV -->

    <ContainerFlex>
      <div slot="aside-left" class="hidden lg:block">
        <AsideLeft>
          <template slot="title"> Weitere Referenzen </template>
          <li
            v-for="service in similars"
            :key="service.id"
            class="category-left transition"
          >
            <nuxt-link :to="service.url" class="cursor-pointer">
              {{ service.title }}
            </nuxt-link>
          </li>
        </AsideLeft>
      </div>
      <template slot="main-content">
        <div class="mx-4 lg:mx-0">
          <thumbnail-image-slider
            v-if="images && images.length > 0"
            :images="images"
          />
          <components-loader :components="components" />
        </div>
      </template>
      <template slot="aside-right">
        <AsideRight :coworker="consulter" />
      </template>
    </ContainerFlex>
  </div>
</template>

<script>
import MenuMain from '~/components/menu/MenuMain'
import ContainerFlex from '~/components/layoutelements/ContainerFlex'
import AsideLeft from '~/components/layoutelements/AsideLeft'
import AsideRight from '~/components/layoutelements/AsideRight'
import ThumbnailImageSlider from '~/components/ThumbnailImageSlider'

export default {
  components: {
    MenuMain,
    ContainerFlex,
    AsideLeft,
    AsideRight,
    ThumbnailImageSlider,
  },

  async asyncData({ route, $axios }) {
    const result = await $axios.$get(route.path)
    return result
  },
  data() {
    return {}
  },
}
</script>
